import { setCurrentEmployeeId } from 'helpers/Utils';
import { LOGIN_SUCCESS } from './constants';

const INIT_STATE = {
  isAuth: false,
  token: null,
  expires: null,
  email: null,
  errorMessage: null,
  isPending: false,
};

export default (localState = INIT_STATE, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS: {
      const { email, token, expires, firstName, lastName, employeeId } =
        action.payload;
      setCurrentEmployeeId(employeeId);
      return {
        ...localState,
        email,
        token,
        firstName,
        lastName,
        employeeId,
        expires,
        isAuth: true,
      };
    }
    default:
      return { ...localState };
  }
};
